import { render } from "./Live.vue?vue&type=template&id=5c698f6a&ts=true"
import script from "./Live.vue?vue&type=script&lang=ts"
export * from "./Live.vue?vue&type=script&lang=ts"

import "./Live.vue?vue&type=style&index=0&id=5c698f6a&lang=scss"

import exportComponent from "/workspace/hound-platform/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__